import React, { useState } from 'react';

import PhotoAlbum from "react-photo-album";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import scaryDay1 from './assets/images/expect/scary/day1/A1.jpg';
import scaryDay2 from './assets/images/expect/scary/day1/B1.jpg';
import scaryDay3 from './assets/images/expect/scary/day1/C1.jpg';
import scaryDay4 from './assets/images/expect/scary/day1/D1.jpg';
import scaryDay5 from './assets/images/expect/scary/day1/E1.jpg';
import scaryDay6 from './assets/images/expect/scary/day1/F1.jpg';
import scaryDay7 from './assets/images/expect/scary/day1/H1.jpg';
import scaryDay8 from './assets/images/expect/scary/day1/I1.jpg';

const photos1 = [
    { src: scaryDay1, width: 157, height: 210 }
];

const photos2 = [
    { src: scaryDay1 },
    { src: scaryDay2 },
    { src: scaryDay3 },
    { src: scaryDay4 },
    { src: scaryDay5 },
    { src: scaryDay6 },
    { src: scaryDay7 },
    { src: scaryDay8 }
];

const Candyd1 = () => {
    const [index, setIndex] = useState(-1);
    return (
        <div className="litter-gallery">
            <PhotoAlbum photos={photos1} layout="rows" targetRowHeight={150} onClick={({ index }) => setIndex(index)} />
            <Lightbox
                slides={photos2}
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
            />
        </div>
    )

}

export default Candyd1;
